export default __webpack_public_path__ + "static/sorry-illustration-770f910d3a7a3caa573fbd6f396b8741.png";